import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Phone, Tag, VideoFull, FeatureCard } from '@unmind/design-system';
import { tracking } from 'App/Tracking';
import { getTextPath } from 'Book/pages/Service/lib';
import { Section } from './ServiceGroup.styles';

export interface ServiceCardProps {
  id: string;
  link: string;
  description?: string;
  name: string;
}
export interface ServiceGroupProps {
  cards: ServiceCardProps[];
  title: string;
  group: string;
  description?: string;
}

const ServiceGroup = ({
  cards,
  title,
  group,
  description,
}: ServiceGroupProps) => {
  const { t } = useTranslation('book');
  const allowanceText = getTextPath(group, 'allowance', 'book.wpo_services');

  if (!cards || !cards.length) return <></>;

  return (
    <Section data-testid={`service-group-${group}`}>
      <h3>
        {title}
        <Tag
          label={t(allowanceText)}
          variant="secondary"
          LeftIcon={[Phone, VideoFull]}
        />
      </h3>
      {description ? <p>{description}</p> : <></>}
      <ul>
        {cards?.map(card => (
          <li key={card.id} data-testid={card.id}>
            <FeatureCard
              titleAsChild
              description={card.description ? card.description : undefined}
              icon={{
                name: 'arrow-right',
                variant: 'icon-small',
              }}
              size="small"
              onClick={() =>
                tracking.track('book_eap_service_card_clicked', {
                  service: card.name,
                })
              }
            >
              <Link to={card.link}>{card.name}</Link>
            </FeatureCard>
          </li>
        ))}
      </ul>
    </Section>
  );
};

export default ServiceGroup;
